import { render, staticRenderFns } from "./grab-bags.vue?vue&type=template&id=189ac234"
import script from "./grab-bags.vue?vue&type=script&lang=js"
export * from "./grab-bags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ServicesHeader: require('/opt/atlassian/pipelines/agent/build/components/services/ServicesHeader.vue').default,ServicesBagSizes: require('/opt/atlassian/pipelines/agent/build/components/services/BagSizes.vue').default,BusinessReview: require('/opt/atlassian/pipelines/agent/build/components/business/BusinessReview.vue').default,GridWrapper: require('/opt/atlassian/pipelines/agent/build/components/GridWrapper.vue').default,HomePageSection: require('/opt/atlassian/pipelines/agent/build/components/HomePageSection.vue').default})
